import {Button, Flex, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {CircularLoader} from '../../../components/CircularLoader/CircularLoader';
import FieldSelect from '../componenets/FieldSelectDialog/FieldsSelectDialog';
import FieldTable from '../componenets/FieldsTable';
import ReportData from '../componenets/ReportData';
import {reportGeneratorsStore} from '../stores/ReportGeneratorsStore';
import texts from '../texts';
import styles from './styles.module.scss';
import {useFieldsQuery} from '../useFieldQuery';
import {createDataTestId} from '../../../utils/dataTestId';
import {isRTL} from '../../../Localization';
import {handleAddExpression, handleOpenFieldSelect, handleToggleFieldsDialog} from '../actions';
import {CheckBoxItem} from '../componenets/CheckBoxItem';

const ReportGeneratorPage = observer(() => {
    const {currentScreen} = reportGeneratorsStore;
    const {currentReport, isFieldsDialogOpen} = currentScreen;
    const {isMultiCompany, toggleIsMultiCompany, columns, isNew} = currentReport;
    const {isLoadingFields, isLoadingReportData, fields} = useFieldsQuery(currentScreen);

    const isExpressionDisabled =
        !columns?.length || columns.some(col => !col.IsExpression && !col.IsCompany && !col.ColId);

    return (
        <div className={styles.container}>
            {isLoadingReportData && !isNew ? (
                <Flex justifyContent="center" componentClasses={styles.loader}>
                    <CircularLoader />
                </Flex>
            ) : (
                <>
                    <div className={styles.header}>
                        <ReportData />
                    </div>
                    <div className={styles.reportPageContent} dir={isRTL() ? 'rtl' : 'ltr'}>
                        <Flex
                            justifyContent="flex-start"
                            componentClasses={styles.reportPageActionsWrppaer}
                            {...createDataTestId('new-report-action-buttons', true)}
                        >
                            <Button
                                prefixIcon={PriorityIcon.addSmall}
                                width="contentWidth"
                                onClick={handleOpenFieldSelect}
                            >
                                {texts.addFieldBtn}
                            </Button>
                            <Button
                                disabled={isExpressionDisabled}
                                width="contentWidth"
                                skin="secondary"
                                onClick={handleAddExpression}
                            >
                                {texts.addExpressBtn}
                            </Button>
                            <Separator align="horizontal" height={30} />
                            <CheckBoxItem
                                title={texts.multiCheckBox}
                                isChecked={isMultiCompany}
                                helpText={texts.multiCompanyHelp}
                                onClick={toggleIsMultiCompany}
                            />
                        </Flex>
                        {isFieldsDialogOpen && (
                            <FieldSelect
                                isLoadingFields={isLoadingFields}
                                fields={fields?.all || []}
                                onClose={() => handleToggleFieldsDialog(false)}
                            />
                        )}

                        <FieldTable />
                    </div>
                </>
            )}
        </div>
    );
});

export default ReportGeneratorPage;
